module.exports = __webpack_public_path__ + "54e3d7f5291b53dd8e2cccfc2f7d8967.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-light.ttf
 ** module id = 5
 ** module chunks = 0
 **/